(() => {
  'use strict';
  const search = document.querySelector('[data-oil-search]');
  const results = [...document.querySelectorAll('[data-oil-results] a')];
  search?.addEventListener('input', () => {
    const query = search.value.trim().toLocaleLowerCase();
    results.forEach(link => { link.hidden = !link.textContent.toLocaleLowerCase().includes(query); });
    const count = results.filter(link => !link.hidden).length;
    document.querySelector('[data-search-status]').textContent = count ? `${count} ${count === 1 ? 'oil' : 'oils'} found.` : 'No oils found. Try a different name.';
  });
  document.querySelector('[data-home-bag-open]')?.addEventListener('click', () => {
    let bag = [];
    try {
      const saved = JSON.parse(localStorage.getItem('gentlemen-farmers-preview-bag-v2') || '[]');
      if (Array.isArray(saved)) bag = saved.filter(item => item && typeof item.title === 'string' && typeof item.url === 'string' && /^\/products\/[a-z-]+\/$/.test(item.url) && typeof item.image === 'string' && item.image.startsWith('/assets/') && Number.isFinite(item.price) && item.price >= 0 && Number.isInteger(item.quantity) && item.quantity > 0 && item.quantity <= 99);
    } catch { /* A fresh bag is usable when browser storage is unavailable. */ }
    const lines = document.querySelector('[data-home-bag-lines]');
    lines.replaceChildren();
    const money = value => new Intl.NumberFormat('en-IE', {style: 'currency', currency: 'EUR'}).format(value / 100);
    bag.forEach(item => {
      const link = document.createElement('a'); link.href = item.url;
      const photo = document.createElement('img'); photo.src = item.image; photo.alt = item.title;
      const text = document.createElement('span'); text.textContent = `${item.title} · ${item.quantity} × ${money(item.price)}`;
      link.append(photo, text); lines.append(link);
    });
    document.querySelector('[data-home-bag-total]').textContent = bag.length ? `Subtotal ${money(bag.reduce((sum, item) => sum + item.price * item.quantity, 0))}` : 'Good things belong here. Your bag is empty.';
  });
})();
